import type { BridgeMessage, BridgeReply } from '../../models/bridge-message';

/**
 * O canal transporta string, então tudo passa por aqui.
 *
 * `JSON.stringify` pode **lançar** — uma referência circular, um `BigInt` — e um throw no
 * caminho de serialização mataria o handler que o chamou. Como o payload do `share` carrega uma
 * data URL de centenas de KB montada em outro lugar, o risco não é teórico.
 */
export function bridgeSerialize(value: BridgeMessage | BridgeReply): string | null {
  try {
    return JSON.stringify(value);
  } catch {
    return null;
  }
}
